import { render } from "./HomePageOne.vue?vue&type=template&id=31d0e6f8&scoped=true"
import script from "./HomePageOne.vue?vue&type=script&lang=js"
export * from "./HomePageOne.vue?vue&type=script&lang=js"

import "./HomePageOne.vue?vue&type=style&index=0&id=31d0e6f8&scoped=true&lang=css"

import exportComponent from "/Users/czh/Desktop/czh/yog_website/lada/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d0e6f8"]])

export default __exports__